// Homepage - scroll to quiz section 
(function() {
  $('[href="#quiz"], [href="/#quiz"], [id$="__image_with_text_z6zCBW"] .image-with-text__media').click(function(e) {
    var quizEl = $('#quiz');
    if (quizEl.length) {
      e.preventDefault();
      var top = quizEl.offset().top - 50;
      $('html, body').animate({ scrollTop: top}, 700, 'linear');
    }
  });
})();


// FAQ page - scroll links
(function() {
  $('[id$="__multicolumn_nKp7n3"] .multicolumn__block-link[href^="#"]').click(function(e) {
    var selector = $(this).attr('href');
    var scrollEl = $(selector);
    if (scrollEl.length) {
      e.preventDefault();
      var top = scrollEl.offset().top - 50;
      $('html, body').animate({ scrollTop: top}, 700, 'linear');
    }
  });
})();

// PDP page - thumbnails vertical carousel
(function() {
  var sliderComponent = 
    document.querySelector('.product-jubileetv-new-template .thumbnail-slider')
    || document.querySelector('.product-all-in-new-template .thumbnail-slider')
    || document.querySelector('.product-pay-later-60-new-template .thumbnail-slider');
  if (sliderComponent && window.matchMedia('(min-width: 750px)').matches) {
    var slider = sliderComponent.querySelector('[id^="Slider-"]');
    var sliderItems = sliderComponent.querySelectorAll('[id^="Slide-"]');
    var prevButton = sliderComponent.querySelector('button[name="previous"]');
    var nextButton = sliderComponent.querySelector('button[name="next"]');
    var sliderItemOffset = sliderItems[1].offsetTop - sliderItems[0].offsetTop;

    setTimeout(function(){
      prevButton.setAttribute('disabled', 'disabled');
      nextButton.removeAttribute('disabled');
    }, 1000);

    slider.addEventListener('scroll', function() {
      if (this.scrollTop === 0) {
        prevButton.setAttribute('disabled', 'disabled');
      } else {
        prevButton.removeAttribute('disabled');
      }
  
      if (this.scrollHeight - this.scrollTop <= this.clientHeight) {
        nextButton.setAttribute('disabled', 'disabled');
      } else {
        nextButton.removeAttribute('disabled');
      }
    });
    
    prevButton.addEventListener('click', function(event) {
      event.preventDefault();
      const step = event.currentTarget.dataset.step || 1;
      const position = slider.scrollTop - step * sliderItemOffset;
      slider.scrollTo({
        top: position,
      });
    });

    nextButton.addEventListener('click', function(event) {
      event.preventDefault();
      const step = event.currentTarget.dataset.step || 1;
      const position = slider.scrollTop + step * sliderItemOffset;
      slider.scrollTo({
        top: position,
      });
    });
  }
})();

// PDP page - show video link
(function() {
  var showVideoLink = document.querySelector('.product__show-video-link');
  var videoThumbnailButton = document.querySelector('#thumbnail-video');
  if (showVideoLink && videoThumbnailButton) {
    showVideoLink.addEventListener('click', function(event) {
      event.preventDefault();
      videoThumbnailButton.click();
    });
  }
})();













